/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, RemovePayload } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import adminUserMgmtAccessRoleApi from "api/adminUserMgmtAccessRoleApi";
import { adminUserMgmtAccessRoleActions } from "./accessRoleSlice";
import { AccessRole, AccessRolePayload } from "models/accessRole";

function* getAccessRoleList(action: PayloadAction<AccessRolePayload>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAccessRoleApi.getAccessRoleList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAccessRoleActions.getAccessRoleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(adminUserMgmtAccessRoleActions.getAccessRoleListFailed(errorData));
  }
}

function* getAccessRoleById(action: PayloadAction<AccessRolePayload>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAccessRoleApi.getAccessRolebyId,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAccessRoleActions.getAccessRoleByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(adminUserMgmtAccessRoleActions.getAccessRoleByIdFailed(errorData));
  }
}

function* getModuleList(action: PayloadAction<AccessRolePayload>) {
  try {
    const response: ApiResponse = yield call(adminUserMgmtAccessRoleApi.getModuleList);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAccessRoleActions.getModuleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(adminUserMgmtAccessRoleActions.getModuleListFailed(errorData));
  }
}

function* getModuleListById(action: PayloadAction<AccessRolePayload>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAccessRoleApi.getModuleById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAccessRoleActions.getModuleByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(adminUserMgmtAccessRoleActions.getModuleByIdFailed(errorData));
  }
}

function* getAllPermissions(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(adminUserMgmtAccessRoleApi.getAllPermissions);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAccessRoleActions.getAllPermissionsSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(adminUserMgmtAccessRoleActions.getAllPermissionsFailed(errorData));
  }
}

function* addAccessRole(action: PayloadAction<AccessRole>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAccessRoleApi.addAccessRole,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtAccessRoleActions.addAccessRoleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtAccessRoleActions.addAccessRoleFailed(errorData));
  }
}

function* updateAccessRole(action: PayloadAction<AccessRole>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAccessRoleApi.updateAccessRole,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtAccessRoleActions.updateAccessRoleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtAccessRoleActions.updateAccessRoleFailed(errorData));
  }
}

function* deleteAccessRole(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAccessRoleApi.deleteAccessRole,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtAccessRoleActions.deleteAccessRoleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtAccessRoleActions.deleteAccessRoleFailed(errorData));
  }
}

export default function* adminUserMgmtAccessRoleSaga() {
  yield takeLatest(adminUserMgmtAccessRoleActions.getAccessRoleList.type, getAccessRoleList);
  yield takeLatest(adminUserMgmtAccessRoleActions.getAccessRoleById.type, getAccessRoleById);
  yield takeLatest(adminUserMgmtAccessRoleActions.getModuleList.type, getModuleList);
  yield takeLatest(adminUserMgmtAccessRoleActions.getModuleById.type, getModuleListById);
  yield takeLatest(adminUserMgmtAccessRoleActions.getAllPermissions.type, getAllPermissions);
  yield takeLatest(adminUserMgmtAccessRoleActions.addAccessRole.type, addAccessRole);
  yield takeLatest(adminUserMgmtAccessRoleActions.updateAccessRole.type, updateAccessRole);
  yield takeLatest(adminUserMgmtAccessRoleActions.deleteAccessRole.type, deleteAccessRole);
}
